import { ComponentType, LazyExoticComponent, lazy } from 'react';
import { BotSourceType } from '../types/bot-sources/BotSourceType';
// Use the icon-only Cloudflare mark (chmurka) — the full wordmark logo is too wide
// for the 52px source-row tile and disappears visually next to the square Fastly /
// log-upload marks. Asset is the same artwork as `logo-cloudflare.svg` with the
// "Cloudflare" wordmark paths stripped.
import cloudflareLogo from '../../assets/icons/logo-cloudflare-mark.svg';
// Fastly integration is temporarily hidden from clients. Keep the import line
// commented to make it easy to re-enable when ready.
// import fastlyLogo from '../../assets/icons/logo-fastly.svg';

type DeliveryMode = 'pull_api' | 'push_file_upload';

export interface ConnectDialogProps {
  projectId: number;
  visible: boolean;
  onClose: () => void;
  onSuccess: () => void;
  // Extra props specific to individual dialogs.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
}

export interface BotSourceProviderConfig {
  type: BotSourceType;
  displayName: string;
  iconClass: string;
  logoPath: string | null;
  descriptionKey: string;
  titleKey: string;
  deliveryMode: DeliveryMode;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  dialogComponent: LazyExoticComponent<ComponentType<any>> | null;
}

export const BOT_SOURCES: Partial<Record<BotSourceType, BotSourceProviderConfig>> = {
  cloudflare: {
    type: 'cloudflare',
    displayName: 'Cloudflare',
    iconClass: 'ico--cloudflare',
    logoPath: cloudflareLogo,
    descriptionKey: 'providers.cloudflare.description',
    titleKey: 'providers.cloudflare.title',
    deliveryMode: 'pull_api',
    dialogComponent: lazy(
      () => import('../../pages/bots-activity/components/dialogs/CloudflareConnectDialog')
    ),
  },
  log: {
    type: 'log',
    displayName: 'Log file upload',
    iconClass: 'ico--clipboard',
    logoPath: null,
    descriptionKey: 'providers.log.description',
    titleKey: 'providers.log.title',
    deliveryMode: 'push_file_upload',
    dialogComponent: lazy(() => import('../../pages/bots-activity/components/dialogs/LogUploadDialog')),
  },
  // Fastly integration is temporarily hidden from clients. Keep the entry
  // commented to make it easy to re-enable when ready.
  // fastly: {
  //   type: 'fastly',
  //   displayName: 'Fastly',
  //   iconClass: 'ico--fastly',
  //   logoPath: fastlyLogo,
  //   descriptionKey: 'providers.fastly.description',
  //   titleKey: 'providers.fastly.title',
  //   deliveryMode: 'pull_api',
  //   dialogComponent: lazy(
  //     () => import('../../pages/bots-activity/components/dialogs/FastlyConnectDialog')
  //   ),
  // },
};
